<template>
    <div class="content-null" :style="{ height: height ? height + 'px' : 'auto' }">{{ tip }}</div>
</template>

<script>
export default {
    name: 'NullView',
    props: {
        tip: {
            type: String,
            default: () => ''
        },
        height: {
            type: Number,
            default: () => 20
        }
    },
}
</script>

<style lang="scss" scoped>
.content-null {
    width: 100%;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a0a0a0;
}
</style>